import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';

const SuperTrackingChart = ({ previous, current, currentMonth = moment() }) => {
  const isIncreasing = current >= previous;

  const previousMonth = moment(currentMonth).subtract(1, 'month').format('MMMM');
  const currentMonthName = moment(currentMonth).format('MMMM');

  const options = {
    chart: {
      type: 'area',
      height: 122,
      spacing: [0, 0, 0, 0],
    },
    title: {
      text: "Super Tracking%",
      style:{
        fontSize:'16px'
      }
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      visible: false,
    },
    yAxis: {
      visible: false,
      min:isIncreasing ? previous : current
    },
    tooltip: {
      enabled: false,
    },
    plotOptions: {
      area: {
        marker: {
          enabled: true,
          radius: 5,
          symbol: 'circle',
        },
        fillOpacity: 0.2,
      },
      series: {
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            const labelMonth = this.point.name;
            const labelValue = this.y.toFixed(2) + '%';

            return `
              <div style="text-align:center;">
                <div style="font-weight:bold; font-size:14px; color:#000;">${labelValue}</div>
                <div style="font-size:11px; padding: 2px 8px; background: #fff; border-radius: 12px; box-shadow: 0 0 4px rgba(0,0,0,0.2); display: inline-block; margin-top: 2px;">
                  ${labelMonth}
                </div>
              </div>
            `;
          },
        },
      },
    },
    series: [
      {
        name: 'Super Tracking %',
        data: [
          { y: previous, name: previousMonth },
          { y: current, name: currentMonthName },
        ],
        type: 'area',
        color: isIncreasing ? '#1BA345' : '#F2545B',
        fillColor: {
            linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
            stops: [
              [0, isIncreasing ? 'rgba(27, 163, 69, 0.5)' : 'rgba(242, 84, 91, 0.5)'], // 👈 increased opacity from 0.2 to 0.5
              [1, isIncreasing ? 'rgba(27, 163, 69, 0.1)' : 'rgba(242, 84, 91, 0.1)']
            ],
          },
          
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
  };

  return (
    <div style={{ width: '100%' }}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default SuperTrackingChart;
